import { render, staticRenderFns } from "./PETRules.vue?vue&type=template&id=77b7c9e2&"
import script from "./PETRules.vue?vue&type=script&lang=js&"
export * from "./PETRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports